<vi-page [sidenavs]="true" [footer]="true" [isWhiteBackground]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING_OVERVIEW' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body layoutAlign="justify-start items-start">
    <ng-container
      main
      *ngIf="(installationsStore.loaded$ | async) && (bookingStore.loaded$ | async); else loader"
    >
      <!-- Booked package -->
      <ng-container
        *ngIf="
          bookingStore.activeOrCanceledCommercialSubscription$ | async as subscription;
          else noPackageBooked
        "
      >
        <div class="packages-header">
          <h1 data-at-title>
            {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.TITLE' | translate }}
          </h1>
        </div>
        <div class="subscriptions-container">
          <app-commercial-status-tile
            [isActiveSubscription]="true"
            [subscription]="subscription"
          ></app-commercial-status-tile>
        </div>
      </ng-container>

      <!-- No booked package notification -->
      <ng-template #noPackageBooked>
        <div class="packages-header">
          <h1 data-at-title>
            {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.TITLE' | translate }}
          </h1>
          <vi-text class="no-package-info">
            {{ '+BOOKING.OVERVIEW.COMMERCIAL.NO_PACKAGE_BOOKED' | translate }}
          </vi-text>
        </div>
      </ng-template>

      <!-- Expired packages -->
      <ng-container
        *ngIf="bookingStore.expiredCommercialSubscriptions$ | async as expiredSubscriptions"
      >
        <ng-container *ngIf="expiredSubscriptions.length">
          <div class="packages-header">
            <h2 data-at-title>
              {{ '+BOOKING.OVERVIEW.COMMERCIAL.EXPIRED_SUBSCRIPTIONS' | translate }}
            </h2>
          </div>
          <div class="subscriptions-container">
            <ng-container *ngFor="let expiredSubscription of expiredSubscriptions">
              <app-commercial-status-tile
                [subscription]="expiredSubscription"
                [isAnyActiveOrCancelledSubscription]="
                  !!(bookingStore.activeOrCanceledFlatRateSubscription$ | async)
                "
              ></app-commercial-status-tile>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #loader>
      <vi-loader main [isLoading]="true"></vi-loader>
    </ng-template>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
